// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/ocr.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/ocr.proto.
 */
export const file_api_proto_v1_ocr: GenFile = /*@__PURE__*/
  fileDesc("ChZhcGlfcHJvdG8vdjEvb2NyLnByb3RvEgxhcGlfcHJvdG8udjEiQAoZUmVjb2duaXplTWVtb0ltYWdlUmVxdWVzdBIjCgVpbWFnZRgBIAEoCzIULmFwaV9wcm90by52MS5VcGxvYWQiKgoaUmVjb2duaXplTWVtb0ltYWdlUmVzcG9uc2USDAoEdGV4dBgBIAEoCUIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM", [file_api_proto_v1_file]);

/**
 * 写真 OCR (issue #2222 / openspec: ocr-recognition-api)。
 * メモ写真の文字起こしテキストを返すだけの API。案件フィールドへの正規化は
 * 既存のかんたん案件登録パイプライン (note → ParseDealEasyText) が担う。
 *
 * @generated from message api_proto.v1.RecognizeMemoImageRequest
 */
export type RecognizeMemoImageRequest = Message<"api_proto.v1.RecognizeMemoImageRequest"> & {
  /**
   * メモ写真 (jpg/png)
   *
   * @generated from field: api_proto.v1.Upload image = 1;
   */
  image?: Upload;
};

/**
 * Describes the message api_proto.v1.RecognizeMemoImageRequest.
 * Use `create(RecognizeMemoImageRequestSchema)` to create a new message.
 */
export const RecognizeMemoImageRequestSchema: GenMessage<RecognizeMemoImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ocr, 0);

/**
 * @generated from message api_proto.v1.RecognizeMemoImageResponse
 */
export type RecognizeMemoImageResponse = Message<"api_proto.v1.RecognizeMemoImageResponse"> & {
  /**
   * 文字起こし結果 (複数行は改行区切り)
   *
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message api_proto.v1.RecognizeMemoImageResponse.
 * Use `create(RecognizeMemoImageResponseSchema)` to create a new message.
 */
export const RecognizeMemoImageResponseSchema: GenMessage<RecognizeMemoImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ocr, 1);

